(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lightbox", [], factory);
	else if(typeof exports === 'object')
		exports["lightbox"] = factory();
	else
		root["lightbox"] = factory();
})(this, function() {
return 